"use strict";
exports["20f874f0"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizMrsProxyTitleText","properties":{"emailAddress":{"type":"string","title":"LabelEmailAddress","pattern":"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},"userName":{"type":"string","title":"LabelDomainUser","pattern":"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},"password":{"type":"string","title":"LabelPassword"},"mailboxGuid":{"type":"string","title":"LabelMailboxGuid","pattern":"^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"},"useAutodiscover":{"type":"boolean","title":"LabelAutodiscoverGroup","default":true,"enum":[true,false],"enumNames":["LabelUseAutodiscoverRadio","LabelSpecifyWebServiceUrlRadio"]},"ignoreTrustForSsl":{"type":"boolean","title":"LabelIgnoreTrustForSsl","default":false},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["emailAddress","userName","password","mailboxGuid","useAutodiscover","notice","proofOfWork"],"dependencies":{"useAutodiscover":{"oneOf":[{"properties":{"useAutodiscover":{"enum":[false]},"ewsHostName":{"type":"string","title":"LabelEwsHostName","pattern":"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"}},"required":["ewsHostName"]},{"properties":{"useAutodiscover":{"enum":[true]}}}]}},"$id":"20f874f0"};
const pattern0 = new RegExp("^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$", "u");
const pattern1 = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");
const pattern2 = new RegExp("^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");
const pattern3 = new RegExp("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="20f874f0" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.emailAddress === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "emailAddress"},message:"must have required property '"+"emailAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.userName === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.password === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.mailboxGuid === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mailboxGuid"},message:"must have required property '"+"mailboxGuid"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.useAutodiscover === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "useAutodiscover"},message:"must have required property '"+"useAutodiscover"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.notice === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.proofOfWork === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.useAutodiscover !== undefined){
const _errs2 = errors;
let valid1 = false;
let passing0 = null;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.ewsHostName === undefined){
const err7 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf/0/required",keyword:"required",params:{missingProperty: "ewsHostName"},message:"must have required property '"+"ewsHostName"+"'",schema:schema11.dependencies.useAutodiscover.oneOf[0].required,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0],data};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === false)){
const err8 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.ewsHostName !== undefined){
let data1 = data.ewsHostName;
if(typeof data1 === "string"){
if(!pattern0.test(data1)){
const err9 = {instancePath:instancePath+"/ewsHostName",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/ewsHostName/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},message:"must match pattern \""+"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"+"\"",schema:"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.ewsHostName,data:data1};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/ewsHostName",schemaPath:"#/dependencies/useAutodiscover/oneOf/0/properties/ewsHostName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.useAutodiscover.oneOf[0].properties.ewsHostName.type,parentSchema:schema11.dependencies.useAutodiscover.oneOf[0].properties.ewsHostName,data:data1};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data2 = data.useAutodiscover;
if(!(data2 === true)){
const err11 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/dependencies/useAutodiscover/oneOf/1/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover.enum,parentSchema:schema11.dependencies.useAutodiscover.oneOf[1].properties.useAutodiscover,data:data2};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err12 = {instancePath,schemaPath:"#/dependencies/useAutodiscover/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.useAutodiscover.oneOf,parentSchema:schema11.dependencies.useAutodiscover,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
}
if(data.emailAddress !== undefined){
let data3 = data.emailAddress;
if(typeof data3 === "string"){
if(!pattern1.test(data3)){
const err13 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/properties/emailAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.properties.emailAddress,data:data3};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/emailAddress",schemaPath:"#/properties/emailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.emailAddress.type,parentSchema:schema11.properties.emailAddress,data:data3};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.userName !== undefined){
let data4 = data.userName;
if(typeof data4 === "string"){
if(!pattern2.test(data4)){
const err15 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/pattern",keyword:"pattern",params:{pattern: "^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.properties.userName,data:data4};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.userName.type,parentSchema:schema11.properties.userName,data:data4};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.password !== undefined){
let data5 = data.password;
if(typeof data5 !== "string"){
const err17 = {instancePath:instancePath+"/password",schemaPath:"#/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.password.type,parentSchema:schema11.properties.password,data:data5};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.mailboxGuid !== undefined){
let data6 = data.mailboxGuid;
if(typeof data6 === "string"){
if(!pattern3.test(data6)){
const err18 = {instancePath:instancePath+"/mailboxGuid",schemaPath:"#/properties/mailboxGuid/pattern",keyword:"pattern",params:{pattern: "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"},message:"must match pattern \""+"^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"+"\"",schema:"^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$",parentSchema:schema11.properties.mailboxGuid,data:data6};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/mailboxGuid",schemaPath:"#/properties/mailboxGuid/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.mailboxGuid.type,parentSchema:schema11.properties.mailboxGuid,data:data6};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.useAutodiscover !== undefined){
let data7 = data.useAutodiscover;
if(typeof data7 !== "boolean"){
const err20 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.useAutodiscover.type,parentSchema:schema11.properties.useAutodiscover,data:data7};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(!((data7 === true) || (data7 === false))){
const err21 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema11.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.useAutodiscover.enum,parentSchema:schema11.properties.useAutodiscover,data:data7};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.ignoreTrustForSsl !== undefined){
let data8 = data.ignoreTrustForSsl;
if(typeof data8 !== "boolean"){
const err22 = {instancePath:instancePath+"/ignoreTrustForSsl",schemaPath:"#/properties/ignoreTrustForSsl/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.ignoreTrustForSsl.type,parentSchema:schema11.properties.ignoreTrustForSsl,data:data8};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.notice !== undefined){
let data9 = data.notice;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.testAccountConsent === undefined){
const err23 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data9};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data9.testAccountConsent !== undefined){
let data10 = data9.testAccountConsent;
if(typeof data10 !== "boolean"){
const err24 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data10};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
else {
const err25 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data9};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data11 = data.proofOfWork;
if(typeof data11 !== "string"){
const err26 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data11};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["-16cb1543"] = validate11;
const schema12 = {"type":"object","properties":{"useAutodiscover":{"enum":[false]}},"$id":"-16cb1543"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-16cb1543" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === false)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema12.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.useAutodiscover.enum,parentSchema:schema12.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["-7ab24ebe"] = validate12;
const schema13 = {"type":"object","properties":{"useAutodiscover":{"enum":[true]}},"$id":"-7ab24ebe"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-7ab24ebe" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.useAutodiscover !== undefined){
let data0 = data.useAutodiscover;
if(!(data0 === true)){
const err0 = {instancePath:instancePath+"/useAutodiscover",schemaPath:"#/properties/useAutodiscover/enum",keyword:"enum",params:{allowedValues: schema13.properties.useAutodiscover.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.useAutodiscover.enum,parentSchema:schema13.properties.useAutodiscover,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}
